import { Routes, Route } from 'react-router-dom';
import ThreadPage from './components/ThreadPage';
import PrdPreviewPage from './components/PrdPreviewPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ThreadPage />} />
      <Route path="/prd" element={<PrdPreviewPage />} />
    </Routes>
  );
}
